export enum BeneficiaryOrderEnum {
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM',
}
